<div class="content-container">
  <h3>{{ 'setUpTwoFactor.chooseMethod.title' | translate }}</h3>
  <h4>{{ 'setUpTwoFactor.chooseMethod.text' | translate }}</h4>
  <div class="section-container">
    <div class="section-content">
      <h5>
        {{ 'setUpTwoFactor.chooseMethod.authenticatorApp' | translate
        }}<span>{{
          'setUpTwoFactor.chooseMethod.recommended' | translate
        }}</span>
      </h5>
      <p>
        {{ 'setUpTwoFactor.chooseMethod.authenticatorAppText' | translate }}
      </p>
      <button
        mat-flat-button
        class="action-button"
        color="primary"
        type="submit"
        (click)="onAppSetUp()"
      >
        {{ 'setUpTwoFactor.chooseMethod.authenticatorAppButton' | translate }}
      </button>
    </div>
    <hr />
    <div class="section-content">
      <h5>
        {{ 'setUpTwoFactor.chooseMethod.email' | translate }}
      </h5>
      <p>
        {{ 'setUpTwoFactor.chooseMethod.emailText' | translate }}
      </p>
      <button
        mat-flat-button
        class="action-button"
        color="primary"
        type="submit"
        (click)="onEmailSetUp()"
      >
        {{ 'setUpTwoFactor.chooseMethod.emailButton' | translate }}
      </button>
    </div>
  </div>
  <button
    mat-stroked-button
    class="cancel-button"
    type="submit"
    (click)="onDismiss()"
  >
    {{ 'setUpTwoFactor.chooseMethod.notNow' | translate }}
  </button>
</div>
